var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28416 1.83209C7.97813 1.83209 7.73026 2.08016 7.73026 2.38599V10.9721L4.27913 7.50439C4.06274 7.28801 3.71168 7.28801 3.4953 7.50439C3.27891 7.72097 3.27891 8.07184 3.4953 8.28823L7.89372 12.6867C7.91942 12.712 7.94724 12.735 7.9768 12.7558H7.99902L8.07108 12.7947H8.10431H8.10412C8.1273 12.8041 8.15145 12.8105 8.17618 12.814C8.21212 12.8182 8.24824 12.8182 8.28418 12.814C8.32108 12.8182 8.35818 12.8182 8.39489 12.814C8.41865 12.8101 8.44183 12.8037 8.46424 12.7947H8.49747L8.56954 12.7558H8.59176L8.67754 12.6867L13.073 8.28823C13.2894 8.07184 13.2894 7.72098 13.073 7.50439C12.8567 7.28801 12.5056 7.28801 12.2892 7.50439L8.83808 10.9582V2.38594C8.83808 2.2391 8.77974 2.09826 8.6758 1.99432C8.57205 1.89037 8.43101 1.83203 8.28418 1.83203L8.28416 1.83209Z",
    fill: "#967842"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8869 15.1666H12.6838C12.9896 15.1666 13.2377 14.9185 13.2377 14.6127C13.2377 14.3067 12.9896 14.0586 12.6838 14.0586H3.8869C3.58107 14.0586 3.33301 14.3067 3.33301 14.6127C3.33301 14.9185 3.58108 15.1666 3.8869 15.1666Z",
    fill: "#967842"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.644d3688b50364b51dc0c4948d16b38a.svg";
export { ForwardRef as ReactComponent };